import { NavMenu } from "./Navmenu.styled";
import ResponsiveNavmenu from "./Responsive/ResponsiveNav";
import Logo from "./Logo/Logo";


function Topbar(): JSX.Element {
  return (
    <NavMenu>
      <Logo />
      <ResponsiveNavmenu />
    </NavMenu>
  );
}

export default Topbar;
